import { createSelector } from '@reduxjs/toolkit';
import { eventOccurrencesNotDeleted } from '../events/event-occurrences-not-deleted';
import { weekStart } from './week-start';
import { LocalDate } from '../../../utilities/local-date';

/**
 * event occurrences given the current value of week start
 */
export const currentWeekEventOccurrences = createSelector(
  eventOccurrencesNotDeleted,
  weekStart,
  (occurrences, weekStart) => {
    const startDate = LocalDate.fromString(weekStart);
    const endDate = startDate.plusDays(6);

    return occurrences.filter((e) => {
      if (e.date === null || e.date === undefined) return false;
      const d = LocalDate.fromString(e.date);

      return d.inRange(startDate, endDate);
    });
  },
);
